
import React from 'react';
import { useGA4ViewEvent } from '../../../hooks/useGA4';

const empathyItems = [
  {
    icon: 'ri-heart-pulse-line',
    title: '夜勤明け、鏡を見るのが辛い',
    desc: '肌荒れ、目の下のクマ…\n疲れた顔が気になる毎日',
  },
  {
    icon: 'ri-group-line',
    title: '家族や友人と予定が合わない',
    desc: '大切な人との時間が取れず、\n孤独を感じる日々',
  },
  {
    icon: 'ri-mental-health-line',
    title: '体力の限界を感じる',
    desc: '「あと何年、体力が持つのだろう…」\nという漠然とした不安',
  },
  {
    icon: 'ri-sun-line',
    title: '生活リズムを整えたい',
    desc: '40代を迎え、健康的な生活を\n強く願っている',
  },
];

export default function EmpathySection() {
  const sectionRef = useGA4ViewEvent('nijikango04_view_empathy');

  return (
    <section ref={sectionRef} id="section-empathy" className="py-12 px-5 bg-white">
      <h2 className="text-[22px] font-bold text-center text-gray-900 mb-10 leading-[1.5]">
        こんな毎日、<br />繰り返していませんか？
      </h2>

      <div className="space-y-4">
        {empathyItems.map((item) => (
          <div
            key={item.title}
            className="bg-pink-50 rounded-2xl p-5 flex items-start gap-4"
          >
            <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i className={`${item.icon} text-2xl text-pink-500`}></i>
            </div>
            <div>
              <h3 className="text-[15px] font-bold text-gray-900 mb-1">
                {item.title}
              </h3>
              <p className="text-[13px] text-gray-600 leading-[1.7] whitespace-pre-line">
                {item.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
